module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"recommended":"(Рекомендуется)"}}')
  delete Component.options._Ctor
}
